import { s360ConfigService } from "../Services/S360Config";

import HWLocalStorage from "./HWLocalStorage";

class HWUser {
  static userInfoStorageKey = () => {
    return s360ConfigService.clientHostId + "-s360-user";
  };

  static user = () => {
    if (!s360ConfigService.isClientHostConfigured()) {
      console.log("Please configure SDK before using user details.");
      return null;
    }
    let cachedUser = HWLocalStorage.load(this.userInfoStorageKey());
    if (!cachedUser) {
      return null;
    }
    return cachedUser;
  };

  static resetUser = () => {
    if (!s360ConfigService.isClientHostConfigured()) {
      console.log("Please configure SDK before resetting user details.");
      return null;
    }
    HWLocalStorage.clearWithPrefix(s360ConfigService.clientHostId);
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("clientChannel");
    sessionStorage.removeItem("agentName");
    sessionStorage.removeItem("agentConnected");
    sessionStorage.removeItem("agentWaiting");
  };

  static updateUserDetails(userDetails) {
    if (!s360ConfigService.isClientHostConfigured()) {
      console.log("Please configure SDK before saving user details.");
      return null;
    }
    let clientChannel = userDetails.clientChannel;
    HWLocalStorage.save(userDetails, this.userInfoStorageKey());
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("clientChannel", clientChannel);
    localStorage.setItem("cometdUser", userDetails.cometUser);
    localStorage.setItem("cometdToken", userDetails.cometToken);
  }

  static isLoggedIn = () => {
    return localStorage.getItem("isLoggedIn");
  };

  static xmppUserName = () => {
    let userData = this.user();
    console.log(userData,"userData")
    if (userData?.clientChannel !== undefined) {
      sessionStorage.setItem("cu",userData.clientChannel)
    }
    return userData ? userData.clientChannel : null;
  };

  static sourceType = () => {
    let userData = this.user();
    return userData ? userData.sourceType : null;
  };

  static sourceId = () => {
    let userData = this.user();
    return userData ? userData.sourceId : null;
  };

  static appId = () => {
    let userData = this.user();
    return userData ? userData.appId : null;
  };

  static customerId = () => {
    let userData = this.user();
    return userData ? userData.customerId : null;
  };

  static customerFirstName = () => {
    let userData = this.user();
    return userData ? userData.customerFirstName : null;
  };

  static customerLastName = () => {
    let userData = this.user();
    return userData ? userData.customerLastName : null;
  };

  static pageName = () => {
    let userData = this.user();
    return userData ? userData.pageName : null;
  };

  static xmppUserPassword = () => {
    let userData = this.user();
    return userData ? userData.clientPass : null;
  };

  // CometD credentials getters for page refresh support
  static cometUser = () => {
    let userData = this.user();
    return userData ? userData.cometUser : null;
  };

  static cometToken = () => {
    let userData = this.user();
    return userData ? userData.cometToken : null;
  };
}

export default HWUser;
